import { render, staticRenderFns } from "./healthInfo.vue?vue&type=template&id=434a7658&scoped=true"
import script from "./healthInfo.vue?vue&type=script&lang=js"
export * from "./healthInfo.vue?vue&type=script&lang=js"
import style0 from "./healthInfo.vue?vue&type=style&index=0&id=434a7658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a7658",
  null
  
)

export default component.exports